module.exports = __webpack_public_path__ + "img/xhs_top.371b9e25.png";